import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQueryWithReauth } from './axiosBaseQuery';
export var apiBaseQuery = createApi({
  baseQuery: axiosBaseQueryWithReauth,
  keepUnusedDataFor: 0,
  refetchOnMountOrArgChange: 30,
  endpoints: function endpoints() {
    return {};
  }
});
var apiBaseReducerPath = apiBaseQuery.reducerPath,
  apiBaseReducer = apiBaseQuery.reducer,
  apiBaseMiddleware = apiBaseQuery.middleware;
export { apiBaseReducerPath, apiBaseReducer, apiBaseMiddleware };